import {
  FEATURE_FLAG_KEYS,
  useFeatureFlag,
  useFeatureFlagsReady,
} from '@/feature-flag';

export interface TeamProfileFlag {
  /** The `teamProfileWeb` flag. False until the CDN flags arrive. */
  enabled: boolean;
  /** The CDN flags have arrived, so `enabled` is final. */
  ready: boolean;
}

/**
 * The public team-profile switch. Entry points only need `enabled` (hidden until it's known);
 * the route guard waits for `ready` so a hard refresh doesn't bounce an allowed user home.
 */
export function useTeamProfileFlag(): TeamProfileFlag {
  const { isEnabled } = useFeatureFlag(FEATURE_FLAG_KEYS.TEAM_PROFILE_WEB);
  const ready = useFeatureFlagsReady();
  return { enabled: isEnabled, ready };
}
